import { render, staticRenderFns } from "./RubriquesTreeEditor.vue?vue&type=template&id=15cc8b7a&scoped=true&"
import script from "./RubriquesTreeEditor.vue?vue&type=script&lang=ts&"
export * from "./RubriquesTreeEditor.vue?vue&type=script&lang=ts&"
import style0 from "./RubriquesTreeEditor.vue?vue&type=style&index=0&id=15cc8b7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cc8b7a",
  null
  
)

export default component.exports